/**
 * Definiamo due oggetti con gli stili dei componenti dell'interfaccia.
 * Il primo oggetto risponde alla chiave 'staticskins' e contiene una lista di oggetti
 * che definiscono staticamente nel file gli stili css dei diversi componenti. Ogni
 * lista è posta sotto una chiave che definisce il customer per la quale quella
 * personalizzazione è stata definita.
 * Il secondo oggetto è definito sotto la chiave 'apiusersskins' e definisce un oggetto
 * template da usare quando la personalizzazione non è definita staticamente, ma è contenuta
 * nel database perchè definita esternamente da un api user.
 * Nel database viene quindi salvata una mappa delle variabili da associare al template per
 * valorizzarlo, ed il riferimento al nome del customer per la quale questa personalizzazione
 * è stata fatta.
 * La funzione 'compose_apiuser_skin' serve proprio a questo, associa le variabili
 * dell'oggetto con la mappa dei colori nel database, alla mappa template 'apiusersskins'
 * che definisce il layout di ciascun componente.
 * Ogni mappa dedicata ad un particolare customer deve avere la forma sottostante
 * dove la chiave "body" deve essere SEMPRE presente, eventualmente con oggetto
 * vuoto. Questa indica l'eventuale personalizzazione da applicare al corpo della
 * pagina dove il compnente risiede. QUESTA FEATURE E' DA UTILIZZARE SOLO SU COMPONENTI
 * CHE SONO VIEW! Infatti se la si usa anche su componenti NON view, al caricamento
 * questi applicheranno il loro style a tutto il body della pagina anche se sono solo
 * parti della stessa. Quindi per componenti NON view va lasciato l'oggetto vuoto.
 *  <nome del customer> : {
 *                          <nome componente vue da personalizzare > : {
 *                                      body : {
 *                                        background: 'white'
 *                                      },
 *                                      ( Altri elementi da personalizzare )
 *                                      ...
 *                         }*
 */
const customerColorMap = {

  /*****************************************************************************
   *             SKIN TEMPLATE PER VARIABILI DEFINITE DA UN API USER
   * E`il template della skin definita da un api user sterno ( es. Ranocchi ) il
   * quale configura la personalizzazione grafica del sistema per i PROPRI clienti.
   * Il set di variabili che definiscono le personalizzazioni per lo api user è fisso
   * altrimenti si dovrebbe chiedere ad esso di aggiornare le impostazioni
   * già settate per tutti i siti personalizzati impostati ogni volta che se ne
   * aggiungesse una nuova.
   * Le impostazioni più "fini" contenute nella mappa json degli stili qui sotto
   * che non riferiscono ad una variabile del set definito, sono modificabili solo
   * modificando e ricompilando il codice, quindi dagli sviluppatori Welfarebit.
   *****************************************************************************/

  compose_apiuser_skin : function ( customization ) {

    let apiuserskins = this.apiusersskins;

    // LOGIN FORM
    apiuserskins.LoginForm.body.background = customization.login_pages.main_background;
    apiuserskins.LoginForm.img_logo = customization.login_pages.img_logo;
    apiuserskins.LoginForm.form_body.background = customization.login_pages.form_background;
    apiuserskins.LoginForm.form_body.border = '2px solid ' + customization.login_pages.form_border_color;
    apiuserskins.LoginForm.access_button.background = customization.login_pages.button_a_background;
    apiuserskins.LoginForm.access_button.borderColor = customization.login_pages.button_a_border_color;
    apiuserskins.LoginForm.access_button.color = customization.login_pages.button_a_text_color;
    apiuserskins.LoginForm.passwd_lost_button.background = customization.login_pages.button_b_background;
    apiuserskins.LoginForm.passwd_lost_button.borderColor = customization.login_pages.button_b_border_color;
    apiuserskins.LoginForm.passwd_lost_button.color = customization.login_pages.button_b_text_color;

    // PASSWORD RESET FORM
    apiuserskins.PasswordReset.body.background = customization.login_pages.main_background;
    apiuserskins.PasswordReset.img_logo = customization.login_pages.img_logo;
    apiuserskins.PasswordReset.subtitle_text.color = customization.login_pages.info_text_color;
    apiuserskins.PasswordReset.info_text.color = customization.login_pages.info_text_color;
    apiuserskins.PasswordReset.form_body.background = customization.login_pages.form_background;
    apiuserskins.PasswordReset.form_body.border = '2px solid ' + customization.login_pages.form_border_color;
    apiuserskins.PasswordReset.send_button.background = customization.login_pages.button_a_background;
    apiuserskins.PasswordReset.send_button.borderColor = customization.login_pages.button_a_border_color;
    apiuserskins.PasswordReset.send_button.color = customization.login_pages.button_a_text_color;

    // HOME
    apiuserskins.HomeBase.body.background = customization.app_pages.main_background;
    apiuserskins.HomeBase.footer.background = customization.app_pages.alternative_background;
    apiuserskins.HomeBase.footer_text.color = customization.app_pages.text_color;

    // NAVBAR
    apiuserskins.SiteNavbar.nav_logo.img_logo = customization.app_pages.navbar_logo;
    apiuserskins.SiteNavbar.nav_logo.visible = customization.app_pages.navbar_logo_visible;
    apiuserskins.SiteNavbar.navbar.background = customization.app_pages.alternative_background;
    apiuserskins.SiteNavbar.username.color = customization.app_pages.text_color;
    apiuserskins.SiteNavbar.navbar_text_color[ '--text-color' ] = customization.app_pages.text_color;
    apiuserskins.SiteNavbar.navbar_text_color[ '--hover-color' ] = customization.app_pages.hover_text_color;

    // HOME MENU - HOME DIPENDENTE
    apiuserskins.HomeDipendente.header_sezioni.background = customization.app_pages.section_header_background;
    apiuserskins.HomeDipendente.header_sezioni.color = customization.app_pages.section_text_color;

    // HOME MENU - REF. AZIENDALE
    apiuserskins.HomeRefAziendale.header_sezioni.background = customization.app_pages.section_header_background;
    apiuserskins.HomeRefAziendale.header_sezioni.color = customization.app_pages.section_text_color;

    // MENU SERVICE BADGE
    apiuserskins.ServiceBadge.voci_menu.background = customization.app_pages.menu_buttons_background;
    apiuserskins.ServiceBadge.voci_menu.color = customization.app_pages.menu_buttons_text_color;

    // DOCUMENTAZIONE VIEW
    // Non sono definite variabili per questa componente, saranno quindi
    // applicati i colori di default in quanto aggiunta il 1 Dicembre 2023
    // quindi molto tempo dopo aver consegnato la documentazione sulle skin
    // a Ranocchi, se serve quindi aggiornare Ranocchi in merito a questa
    // colorazione ed aggiungere quindi le variabili necessarie.

    return apiuserskins;

  },
  apiusersskins : {
    /**
     * SKIN COMPONENTE - LOGIN FORM
     */
    LoginForm : {
      body : {
        background: null
      },
      // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
      img_logo : null,
      // Stile immagine del login
      img_logo_style : {},
      // Sottotitolo del logo
      // elemento speciale: non contiene solo lo style
      // ma anche variabili per impostarne il contenuto e
      // renderlo o meno visibile
      logo_subtitle : {
        text : '',
        visible : false,
        style : {}
      },
      // Logo inferiore ( posto sotto al form di login )
      // se previsto.
      logo_inf : {
        visible: false,
        img_logo : null,
        style : {}
      },
      // Gruppo form per lo username
      username_text_and_icon : {
        color: "#000000"
      },
      // Gruppo form per la password
      passwd_text_and_icon : {
        color: "#000000"
      },
      // Body del form di login
      form_body : {
        background : null,
        border : null,
        borderRadius: '5px'
      },
      // Pulsante di accesso
      access_button : {
        background: null,
        borderColor: null,
        color: null
      },
      // Pulsante password dimenticata
      passwd_lost_button : {
        background: null,
        borderColor: null,
        color: null
      }
    },
    /**
     * SKIN COMPONENTE - PASSWORD RESET
     * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
     */
    PasswordReset : {
      body : {
        background: null
      },
      // Immagine del login
      img_logo : null,
      // Sottotitolo del form "Reset Password Perduta"
      subtitle_text : {
        color: null
      },
      // Testo informativo della pagina sia in caso di caricamento corretto che di errore
      info_text : {
        color: null
      },
      // Corpo del form
      form_body : {
        background : null,
        border : null,
        borderRadius: '5px'
      },
      // Pulsante di invio
      send_button : {
        background: null,
        borderColor: null,
        color: null
      }
    },
    /**
     * SKIN COMPONENTE - HomeBase
     */
    HomeBase : {
      body : {
        background: null,
      },
      // Colorazione della barra del footer
      footer : {
        /* Le prime due righe rimuovono la proprietà 'flex'
        la quale costringe il testo a partire da sinistra
        anche se il b-navbar-nav riporta la proprietà 'center' */
        display: 'inline-block',
        width: '100%',
        background: null
      },
      // Colorazione del testo del footer
      footer_text : {
        color: null
      }
    },
    /**
     * SKIN COMPONENTE - NAVBAR
     */
    SiteNavbar : {
      body : {
      },
      // Gestice la presenza del logo nella navbar in alto
      // Componente speciale : non è solo uno style da applicare
      // va definisce anche la presenza o meno dell'immagine nella navbar
      nav_logo : {
        // Immagine del login
        img_logo : null,
        visible : null
      },
      // Colore di sfondo della navbar
      navbar : {
        background: null
      },
      // Stile del nome utente
      username : {
        color : null,
        fontWeight: '500'
      },
      // Colore dei testi e delle icone della navbar
      // normalmente ed in hover.
      // Lasciare l'oggetto vuoto per il colore di default.
      // Usa una variabile css per l'applicazione ( vedi
      // il componente per le info )
      navbar_text_color: {
        '--text-color' : null,
        '--hover-color' : null
      }
    },
    /**
     * SKIN COMPONENTE - HOME MENU
     */
    HomeDipendente : {
      body : {
      },
      // Header delle varie sezioni del menù principale
      header_sezioni : {
        background: null,
        color : null
      }
    },
    /**
     * SKIN COMPONENTE - HOME REF AZIENDALE
     */
    HomeRefAziendale : {
      body : {
      },
      // Header delle varie sezioni del menù principale
      header_sezioni : {
        background: null,
        color : null
      }
    },
    /**
     * SKIN COMPONENTE - SERVICE BADGE
     */
    ServiceBadge : {
      body : {
      },
      // Footer delle voci di menù
      voci_menu : {
        padding: '10px',
        background: null,
        color : null
      }
    },
    /**
     * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
     * Colorazione per la pagina della documentazione aggiunta il 1 Dicembre 2023.
     * Ranocchi non ha in specifica le variabili per questa colorazione quindi
     * verranno usati i colori di defualt.
     */
    DocumentazioneView : {
      body : {},
      // Bottoni che aprono/chiudono gli accordion della pagina
      accordion_button : {}
    }
  },
  /*****************************************************************************
   *                SKIN PERSONALIZZATE DEFINITE DA WELFAREBIT
   * Sono le skin che abbiamo definito noi per clienti che si relazionano
   * direttamente con welfarebit. Le definiamo direttamente in questo files
   * di modo tale da poter garantire un livello di personalizzazione maggiore
   *****************************************************************************/
  staticskins : {
    /***************************************
     *            SKIN DI DEFAULT
     ***************************************/
    default : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#373F66'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/welfarebit/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background: '#ecefff',
          border : '2px solid #d8dfff',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#373F66',
          borderColor: '#373F66'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#5A6268',
          borderColor: '#5A6268',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#373F66'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/welfarebit/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          border: '2px solid #d8dfff',
          borderRadius: '5px',
          background: '#ecefff'
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Pulsante di invio
        send_button : {
          background: '#373F66',
          borderColor: '#373F66'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#373F66',
          color: 'white'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/welfarebit/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#373F66',
        },
        // Stile del nome utente
        username : {
          color : 'white'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#373F66',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#373F66',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#373F66',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#373F66',
          '--border-color' : '#373F66',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN PONTI
     ***************************************/
    ponti : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#13412b'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/ponti/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : 'Welfarebit - Ponti Edition',
          visible : true,
          style : {
            color : '#c2aa62',
            fontSize: '1.7em',
            fontWeight: '700'
          }
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#ffffff"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#ffffff"
        },
        // Body del form di login
        form_body : {
          border : '0px',
        },
        // Pulsante di accesso
        access_button : {
          background: '#388460',
          borderColor: '#2a5f46',
          color: '#ebeac3'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#388460',
          borderColor: '#2a5f46',
          color: '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#13412b'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/ponti/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ebeac3"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ebeac3"
        },
        // Corpo del form
        form_body : {
          border: '0px',
          color:'white'
        },
        // Pulsante di invio
        send_button : {
          background: '#388460',
          borderColor: '#2a5f46',
          color: '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#13412b'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/ponti/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#13412b',
        },
        // Stile del nome utente
        username : {
          color : '#ebeac3'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#388460',
          color : '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#388460',
          color : '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#388460',
          color : '#ebeac3'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#13412b',
          '--border-color' : '#13412b',
          '--text-color' : '#ebeac3'
        }
      }
    },
    /***************************************
     *            SKIN LARDINI
     ***************************************/
    lardini : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#efefef'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/lardini/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {
          width: '90%'
        },
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : 'Welfare Aziendale',
          visible : true,
          style : {
            color : '#0E273B',
            fontSize: '1.7em',
            fontWeight: '700'
          }
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #666666',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#666666',
          borderColor: '#666666',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#666666',
          borderColor: '#666666',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#efefef'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/lardini/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          border : '2px solid #666666',
          borderRadius: '5px',
          background : '#ffffff'
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Pulsante di invio
        send_button : {
          background: '#666666',
          borderColor: '#666666',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#666666'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/lardini/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#666666',
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3d3d3d',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3d3d3d',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#666666',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#666666',
          '--border-color' : '#666666',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN DLLGROUP
     ***************************************/
    dllgroup : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/dllgroup/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #09F',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#09F',
          borderColor: '#09F',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#fffff',
          borderColor: '#00000',
          color: '#00000'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/dllgroup/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #09F',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#09F',
          borderColor: '#09F',
          color: '#00000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#e5e5e5'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#333'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/dllgroup/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#333',
          fontWeight: '500'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#333',
          '--hover-color' : '#b5b5b5'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#09F',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#09F',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#09F',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#09F',
          '--border-color' : '#09F',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN AMAP
     ***************************************/
    amap : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/amap/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #0099E6',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#0099E6',
          borderColor: '#0099E6',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#0099E6',
          borderColor: '#0099E6',
          color: '#00000'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/amap/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #0099E6',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#0099E6',
          borderColor: '#0099E6',
          color: '#00000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#004E99'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/amap/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#004E99'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#004E99',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#004E99',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#004E99',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#004E99',
          '--border-color' : '#004E99',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN BIAUTO
     ***************************************/
    biauto : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/biauto/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : 'Welfarebit | biAuto Group',
          visible : true,
          style : {
            color: '#A6A9AC',
            fontSize: '2em',
            fontWeight: 'bold'
          }
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#EFEDEB',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#333',
          borderColor: '#000',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#333',
          borderColor: '#000',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/biauto/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#EFEDEB',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#333',
          borderColor: '#000',
          color: '#00000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#111'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : null,
          visible : false
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#222'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#222',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#222',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#222',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#222',
          '--border-color' : '#222',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *         SKIN ENGINEERING2K
     ***************************************/
    engineering2k : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/engineering2k/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #0F62A3',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#367fa9',
          borderColor: '#122b40',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#367fa9',
          borderColor: '#122b40',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/engineering2k/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #0F62A3',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#367fa9',
          borderColor: '#122b40',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#87b0d1'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/engineering2k/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#87b0d1'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0F62A3',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0F62A3',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#0F62A3',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#0F62A3',
          '--border-color' : '#0F62A3',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN BIELLA
     ***************************************/
    biella : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/biella/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : 'Welfarebit Biella',
          visible : true,
          style : {
            color: '#A6A9AC',
            fontSize: '2em',
            fontWeight: 'bold'
          }
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#EFEDEB',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#0033CC',
          borderColor: '#0033CC',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#0033CC',
          borderColor: '#0033CC',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/biella/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#EFEDEB',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#0033CC',
          borderColor: '#0033CC',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#253848'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : null,
          visible : false
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#253848'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#253848',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#253848',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#253848',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#253848',
          '--border-color' : '#253848',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN BCCFANO
     ***************************************/
    bccfano : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/bccfano/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/bccfano/logo_login_inferiore.png'),
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #21398f',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#21398f',
          borderColor: '#21398f',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#21398f',
          borderColor: '#21398f',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/bccfano/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #21398f',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#21398f',
          borderColor: '#21398f',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#21398f'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/bccfano/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#21398f'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#21398f',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#21398f',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#8fbf21',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#21398f',
          '--border-color' : '#21398f',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *          SKIN ROMAGNABANCA
     ***************************************/
    romagnabanca : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#008d36 url(' + require('@/assets/logos/romagnabanca/sfondo_login.png') + ') no-repeat scroll center bottom'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/romagnabanca/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/romagnabanca/logo_login_inferiore.png'),
          style : {
            border : '1px solid #fffff',
            borderRadius: '5px'
          }
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #d2d6de',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#008d36',
          borderColor: '#008d36',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#008d36',
          borderColor: '#008d36',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#008d36 url(' + require('@/assets/logos/romagnabanca/sfondo_login.png') + ') no-repeat scroll center bottom'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/romagnabanca/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #d2d6de',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#008d36',
          borderColor: '#008d36',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#008d36'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/romagnabanca/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#008d36'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#004d1d',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#004d1d',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#004d1d',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#008d36',
          '--border-color' : '#008d36',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN FIABILIS
     ***************************************/
    fiabilis : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/fiabilis/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #152563',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#e95e41',
          borderColor: '#e95e41',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#e62e78',
          borderColor: '#e62e78',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/fiabilis/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #152563',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#e95e41',
          borderColor: '#e95e41',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#152563'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/fiabilis/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#152563'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#e95e41',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#e95e41',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#122054',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#122054',
          '--border-color' : '#122054',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *    SKIN ONEBROKER - ASSOCONCIATORI
     ***************************************/
    onebroker : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#EBEAE5 url(' + require('@/assets/logos/onebroker/sfondo_login.png') + ') repeat'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/onebroker/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/onebroker/logo_login_inferiore.png'),
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #959F0B',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#44481E',
          borderColor: '#959F0B',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#44481E',
          borderColor: '#959F0B',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#EBEAE5 url(' + require('@/assets/logos/onebroker/sfondo_login.png') + ') repeat'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/onebroker/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#44481E"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#44481E"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #959F0B',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#44481E',
          borderColor: '#959F0B',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#44481E'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/onebroker/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#EBEAE5'
        },
        // Stile del nome utente
        username : {
          color : '#44481E'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#44481E',
          '--hover-color' : '#b5ba87'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#EBEAE5',
          color : '#44481E'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#EBEAE5',
          color : '#44481E'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#44481E',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#44481E',
          '--border-color' : '#44481E',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *          SKIN FLLIPIACENZA
     ***************************************/
    fllipiacenza : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#bf2933'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/fllipiacenza/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #000000',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#7F1D23',
          borderColor: '#7F1D23',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#7F1D23',
          borderColor: '#7F1D23',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#bf2933'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/fllipiacenza/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #000000',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#7F1D23',
          borderColor: '#7F1D23',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#bf2933'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/fllipiacenza/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#bf2933'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#cccccc'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#7F1D23',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#7F1D23',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#bf2933',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#bf2933',
          '--border-color' : '#bf2933',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *          SKIN GRUPPOAEA
     ***************************************/
    gruppoaea : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffbbb8'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/gruppoaea/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #792230',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#b41d2e',
          borderColor: '#b41d2e',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#b41d2e',
          borderColor: '#b41d2e',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffbbb8'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/gruppoaea/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #792230',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#b41d2e',
          borderColor: '#b41d2e',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#ffbbb8'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#424242'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/gruppoaea/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffbbb8'
        },
        // Stile del nome utente
        username : {
          color : '#424242'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#424242',
          '--hover-color' : '#7a7a7a'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#792230',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#792230',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#b41d2e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#b41d2e',
          '--border-color' : '#b41d2e',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *          SKIN KSFPARTNERS
     ***************************************/
    ksfpartners: {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#01243a'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/ksfpartners/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/ksfpartners/logo_login_inferiore.png'),
          style : {
            width: '35%'
          }
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #409ed1',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#4092be',
          borderColor: '#4092be',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#4092be',
          borderColor: '#4092be',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#01243a'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/ksfpartners/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #409ed1',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#4092be',
          borderColor: '#4092be',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#01243a'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/ksfpartners/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#01243a'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3D3D3D',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3D3D3D',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#3D3D3D',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#3D3D3D',
          '--border-color' : '#3D3D3D',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *          SKIN MAHLE
     ***************************************/
    mahle : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#e0e1e2 url(' + require('@/assets/logos/mahle/sfondo_login.gif') + ') repeat'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/mahle/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : 'Welfarebit - Mahle Edition',
          visible : true,
          style : {
            color : '#555',
            fontSize: '2em',
            fontWeight: '700'
          }
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#014984"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#014984"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#014984',
          borderColor: '#00A8FF',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#014984',
          borderColor: '#00A8FF',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#e0e1e2 url(' + require('@/assets/logos/mahle/sfondo_login.gif') + ') repeat'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/mahle/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#014984"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#014984"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #ddd',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#014984',
          borderColor: '#00A8FF',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#ffffff'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#000000'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/mahle/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#000000'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#000000',
          '--hover-color' : '#1E2A63'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#1E2A63',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#1E2A63',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#41b6e6',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#1E2A63',
          '--border-color' : '#1E2A63',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *  SKIN ORIZZONTI ( Consorzio Orizzonti )
     ***************************************/
    orizzonti : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#fffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/orizzonti/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#00000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#00000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #674a91',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#674a91',
          borderColor: '#674a91',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#674a91',
          borderColor: '#674a91',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/orizzonti/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #674a91',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#674a91',
          borderColor: '#674a91',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#8763ba'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/orizzonti/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#8763ba'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#1E2A63'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#e0283f',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#e0283f',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#e9501a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#e9501a',
          '--border-color' : '#e9501a',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN UNOMAGLIA
     ***************************************/
    unomaglia : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#3b567c'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/unomaglia/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#00000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#00000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #3f3f3f',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#3b567c',
          borderColor: '#3f3f3f',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#3b567c',
          borderColor: '#3f3f3f',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#3b567c'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/unomaglia/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #3f3f3f',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#3b567c',
          borderColor: '#3f3f3f',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#3b567c'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/unomaglia/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#3b567c'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#282828'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3b567c',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#3b567c',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#282828',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#3b567c',
          '--border-color' : '#3b567c',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *            SKIN TECNOPRESS
     ***************************************/
    tecnopres : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#007cba'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/tecnopres/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#00000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#00000"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #d6a918',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#007cba',
          borderColor: '#007cba',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#007cba',
          borderColor: '#007cba',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#007cba'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/tecnopres/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #d6a918',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#007cba',
          borderColor: '#007cba',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#007cba'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/tecnopres/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#007cba'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#d6a918'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#007cba',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#007cba',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#d6a918',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#d6a918',
          '--border-color' : '#d6a918',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***************************************
     *         SKIN SPORTELLOLIA
     ***************************************/
    sportellolia : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/sportellolia/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#23527c"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#23527c"
        },
        // Body del form di login
        form_body : {
          background : '#ECF0F5',
          border : '2px solid #AAA',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#23527c',
          borderColor: '#23527c',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#23527c',
          borderColor: '#23527c',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/sportellolia/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#ECF0F5',
          border : '2px solid #AAA',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#23527c',
          borderColor: '#23527c',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#0d4382'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/sportellolia/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#0d4382'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#0d4382',
          '--hover-color' : '#d6a918'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0d4382',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0d4382',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#ffd602',
          color : '#0d4382'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#ffd602',
          '--border-color' : '#ffd602',
          '--text-color' : '#0d4382'
        }
      }
    },
    /***************************************
     *         SKIN ALMALAUREA
     ***************************************/
    almalaurea : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#f5f5f5'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/almalaurea/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#13294B"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#13294B"
        },
        // Body del form di login
        form_body : {
          background : '#F0B323',
          border : '2px solid #13294B',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#13294B',
          borderColor: '#13294B',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#13294B',
          borderColor: '#13294B',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#f5f5f5'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/almalaurea/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#13294B"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#13294B"
        },
        // Corpo del form
        form_body : {
          background : '#F0B323',
          border : '2px solid #13294B',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#13294B',
          borderColor: '#13294B',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#13294B'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/almalaurea/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#f5f5f5'
        },
        // Stile del nome utente
        username : {
          color : '#13294B'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#13294B',
          '--hover-color' : '#f0b323'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#13294B',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#13294B',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#f0b323',
          color : '#13294B',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#f0b323',
          '--border-color' : '#f0b323',
          '--text-color' : '#13294B'
        }
      }
    },
    /***************************************
     * SKIN ASSA ( Associazione Lavorazioni Conto Terzi )
     ***************************************/
    assa : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/assa/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#212121"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#212121"
        },
        // Body del form di login
        form_body : {
          background : '#f7f7f7',
          border : '2px solid #212121',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#212121',
          borderColor: '#444444',
          color: '#fffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#212121',
          borderColor: '#444444',
          color: '#fffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/assa/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#212121"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#212121"
        },
        // Corpo del form
        form_body : {
          background : '#f7f7f7',
          border : '2px solid #212121',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#212121',
          borderColor: '#444444',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#212121'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/assa/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#212121'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#444444',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#444444',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#7c7c7b',
          color : '#ffffff',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#65c1c3',
          '--border-color' : '#65c1c3',
          '--text-color' : '#ffffff'
        }
      }
    },

    /***********************
    *     SKIN FEDERPOL
    ************************/
    federpol : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/federpol/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#232323"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#232323"
        },
        // Body del form di login
        form_body : {
          background : '#f7f7f7',
          border : '2px solid #232323',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#232323',
          borderColor: '#444444',
          color: '#fffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#232323',
          borderColor: '#444444',
          color: '#fffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/federpol/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#232323"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#232323"
        },
        // Corpo del form
        form_body : {
          background : '#f7f7f7',
          border : '2px solid #232323',
          borderRadius: '5px'
        },
        // Pulsante di invio
        send_button : {
          background: '#232323',
          borderColor: '#444444',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#232323'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/federpol/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#232323'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#449edd'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#444444',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#262626',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#f3f3f3',
          color : '#000000',
          fontWeight: '400'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#f3f3f3',
          '--border-color' : '#f3f3f3',
          '--text-color' : '#000000'
        }
      }
    },

    /***********************
    *     SKIN FEDERDAT
    ************************/
     federdat : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#e8e8e8'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/federdat/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#ffffff"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#ffffff"
        },
        // Body del form di login
        form_body : {
          background : '#1c407c',
          border : '2px solid #a0a0a0',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#e8e8e8',
          borderColor: '#a0a0a0',
          color: '#000000'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#e8e8e8',
          borderColor: '#a0a0a0',
          color: '#000000'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#e8e8e8'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/federdat/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#1c407c',
          border : '2px solid #a0a0a0',
          borderRadius: '5px',
          color: '#ffffff'
        },
        // Pulsante di invio
        send_button : {
          background: '#e8e8e8',
          borderColor: '#a0a0a0',
          color: '#000000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#1c417d'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/federdat/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#1c417d'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#d5d5d5'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#1e4585',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#1e4585',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#e8e8e8',
          color : '#000000',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#e8e8e8',
          '--border-color' : '#e8e8e8',
          '--text-color' : '#000000'
        }
      }
    },

    /***********************
    *     SKIN BLUHOTELS
    ************************/
    bluhotels : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/bluhotels/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#ffffff"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#ffffff"
        },
        // Body del form di login
        form_body : {
          background : '#002b4f',
          border : '2px solid #65c1c3',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/bluhotels/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#002b4f',
          border : '2px solid #65c1c3',
          borderRadius: '5px',
          color: '#ffffff'
        },
        // Pulsante di invio
        send_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#002b4f'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/bluhotels/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#08538e'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#08538e',
          '--hover-color' : '#d5d5d5'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0c365a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0c365a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#65c1c3',
          color : '#ffffff',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#7c7c7b',
          '--border-color' : '#7c7c7b',
          '--text-color' : '#ffffff'
        }
      }
    },

    /***********************
    *     SKIN BLUTRAVEL
    ************************/
    blutravel : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/blutravel/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#ffffff"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#ffffff"
        },
        // Body del form di login
        form_body : {
          background : '#002b4f',
          border : '2px solid #65c1c3',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/blutravel/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#000000"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#000000"
        },
        // Corpo del form
        form_body : {
          background : '#002b4f',
          border : '2px solid #65c1c3',
          borderRadius: '5px',
          color: '#ffffff'
        },
        // Pulsante di invio
        send_button : {
          background: '#65c1c3',
          borderColor: '#a0a0a0',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#002b4f'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/blutravel/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#08538e'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#08538e',
          '--hover-color' : '#d5d5d5'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0c365a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0c365a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#65c1c3',
          color : '#ffffff',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#65c1c3',
          '--border-color' : '#65c1c3',
          '--text-color' : '#ffffff'
        }
      }
    },

    /***********************
    * SKIN WELFARE DI MARCA
    ************************/
    welfaredimarca : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#fbc679'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/welfaredimarca/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#ffffff"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#ffffff"
        },
        // Body del form di login
        form_body : {
          background : '#c2292e',
          border : '2px solid #fdefec',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#ffffff',
          borderColor: '#fdefec',
          color: '#c2292e'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#ffffff',
          borderColor: '#fdefec',
          color: '#c2292e'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#fbc679'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/welfaredimarca/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#c2292e',
          border : '2px solid #fdefec',
          borderRadius: '5px',
          color: '#ffffff'
        },
        // Pulsante di invio
        send_button : {
          background: '#ffffff',
          borderColor: '#fdefec',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#fffaf4'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#fbc679'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#c2292e'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/welfaredimarca/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#fbc679'
        },
        // Stile del nome utente
        username : {
          color : '#c2292e'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#c2292e',
          '--hover-color' : '#fdefec'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#c2292e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#c2292e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#c2292e',
          color : '#ffffff',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#ec3128',
          '--border-color' : '#ec3128',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***********************
    * SKIN BENELLI ARMI
    ************************/
    benelli : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#c1c1c1'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/benelli/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#0d0d0d"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#0d0d0d"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #0d0d0d',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#ec3128',
          borderColor: '#0d0d0d',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#ec3128',
          borderColor: '#0d0d0d',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#c1c1c1'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/benelli/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#0d0d0d"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#0d0d0d"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #0d0d0d',
          borderRadius: '5px',
          color: '#0d0d0d'
        },
        // Pulsante di invio
        send_button : {
          background: '#ec3128',
          borderColor: '#0d0d0d',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#0d0d0d'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/benelli/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#0d0d0d'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#b6b6b6'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#484848',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#484848',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#ec3128',
          color : '#ffffff',
          fontWeight: '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#c2292e',
          '--border-color' : '#c2292e',
          '--text-color' : '#ffffff'
        }
      }
    },
    /***********************
    * SKIN CNA DI ANCONA
    ************************/
    cnaancona : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#485985'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/cnaancona/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background : '#f8f9fa',
          border : '2px solid #000000',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#fbc679',
          borderColor: '#000000',
          color: '#000000'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#fbc679',
          borderColor: '#000000',
          color: '#000000',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#485985'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/cnaancona/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          background : '#f8f9fa',
          border : '2px solid #000000',
          borderRadius: '5px',
          color: '#000000'
        },
        // Pulsante di invio
        send_button : {
          background: '#fbc679',
          borderColor: '#000000',
          color: '#000000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#485985'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/cnaancona/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#485985'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#b6b6b6'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0d2f5e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#0d2f5e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#ffd000',
          color : '#000000',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#ffd000',
          '--border-color' : '#ffd000',
          '--text-color' : '#000000'
        }
      }
    },
    /*********************************
    * SKIN LABORATORIO DELLA FARMACIA
    ***********************************/
    labfarmacia : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/lab_farmacia/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#464b54"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#464b54"
        },
        // Body del form di login
        form_body : {
          background : '#f8f9fa',
          border : '2px solid #59bd7a',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#59bd7a',
          borderColor: '#464b54',
          color: '#000000'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#59bd7a',
          borderColor: '#464b54',
          color: '#000000',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/lab_farmacia/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#464b54"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#464b54"
        },
        // Corpo del form
        form_body : {
          background : '#f8f9fa',
          border : '2px solid #59bd7a',
          borderRadius: '5px',
          color: '#464b54'
        },
        // Pulsante di invio
        send_button : {
          background: '#59bd7a',
          borderColor: '#464b54',
          color: '#000000'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#f8f9fa'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#464b54'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/lab_farmacia/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#f8f9fa'
        },
        // Stile del nome utente
        username : {
          color : '#464b54'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#464b54',
          '--hover-color' : '#91959d'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#59bd7a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#59bd7a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#91959d',
          color : '#ffffff',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#59bd7a',
          '--border-color' : '#59bd7a',
          '--text-color' : '#ffffff'
        }
      }
    },
    /*********************************
    * SKIN ONEBROKERSRL
    ***********************************/
    onebrokersrl : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/onebrokersrl/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#464b54"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#464b54"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #0693e3',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#8ed1fc',
          borderColor: '#0693e3',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#8ed1fc',
          borderColor: '#0693e3',
          color: '#ffffff',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/onebrokersrl/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#464b54"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#464b54"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #0693e3',
          borderRadius: '5px',
          color: '#464b54'
        },
        // Pulsante di invio
        send_button : {
          background: '#8ed1fc',
          borderColor: '#0693e3',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#00b5ca'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/onebrokersrl/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#f8f9fa'
        },
        // Stile del nome utente
        username : {
          color : '#00b5ca'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#00b5ca',
          '--hover-color' : '#16d9e3'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#15325a',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#1559ed',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#8ed1fc',
          color : '#ffffff',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#1559ed',
          '--border-color' : '#1559ed',
          '--text-color' : '#ffffff'
        }
      }
    },
    /******************
    * SKIN CENTROPAGHE
    *******************/
    centropaghe : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/centropaghe/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#6f6f6e"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#6f6f6e"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #c6271e',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#c6271e',
          borderColor: '#c6271e',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#c6271e',
          borderColor: '#c6271e',
          color: '#ffffff',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/centropaghe/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#143c54"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#143c54"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #c6271e',
          borderRadius: '5px',
          color: '#143c54'
        },
        // Pulsante di invio
        send_button : {
          background: '#c6271e',
          borderColor: '#c6271e',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#c6271e'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/centropaghe/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#c6271e'
        },
        // Stile del nome utente
        username : {
          color : '#ffffff'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#ffffff',
          '--hover-color' : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#c6271e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#c6271e',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#6f6f6e',
          color : '#ffffff',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#6f6f6e',
          '--border-color' : '#6f6f6e',
          '--text-color' : '#ffffff'
        }
      }
    },
    /******************
    * SKIN BETTER SILVER
    *******************/
    bettersilver : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#00313c'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/bettersilver/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#000000"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#000000"
        },
        // Body del form di login
        form_body : {
          background: '#ffffff',
          border : '2px solid #001f3c',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#00313c',
          borderColor: '#00313c'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#5A6268',
          borderColor: '#5A6268',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#00313c'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/bettersilver/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#ffffff"
        },
        // Corpo del form
        form_body : {
          border: '2px solid #001f3c',
          borderRadius: '5px',
          background: '#ffffff'
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#ffffff"
        },
        // Pulsante di invio
        send_button : {
          background: '#00313c',
          borderColor: '#00313c'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: 'white'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#00313c',
          color: 'white'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/bettersilver/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#00313c',
        },
        // Stile del nome utente
        username : {
          color : 'white'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {}
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#00313c',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#00313c',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#00313c',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#00313c',
          '--border-color' : '#00313c',
          '--text-color' : '#ffffff'
        }
      }
    },
    /******************
    * SKIN REMEDIA
    *******************/
    remedia : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#E9F6FF'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/remedia/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: false,
          img_logo : null,
          style : {}
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#FFFFFF"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#FFFFFF"
        },
        // Body del form di login
        form_body : {
          background: '#085BAB',
          border : '2px solid #FFCA11',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#FFCA11',
          borderColor: '#E9F6FF',
          color: '#085BAB'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#FFCA11',
          borderColor: '#E9F6FF',
          color: '#085BAB'
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#E9F6FF'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/remedia/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#085BAB"
        },
        // Corpo del form
        form_body : {
          border: '2px solid #FFCA11',
          borderRadius: '5px',
          background: '#085BAB',
          color: "#FFFFFF"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#085BAB"
        },
        // Pulsante di invio
        send_button : {
          background: '#FFCA11',
          borderColor: '#E9F6FF'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#E9F6FF'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#085BAB',
          color: 'white'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/remedia/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#E9F6FF',
        },
        // Stile del nome utente
        username : {
          color : '#085BAB'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#085BAB',
          '--hover-color' : '#FDDC1F'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#085BAB',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#085BAB',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#085BAB',
          color : 'white'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#085BAB',
          '--border-color' : '#FFCA11',
          '--text-color' : '#ffffff'
        }
      }
    },
    /*********************************
    * SKIN DEMO PER INNOVA
    * ATTENZIONE: Anche se andiamo in produzione con il
    * portale nuovo di Innova, questo skin va per ora
    * tenuto per qualche tempo, infatti Innova ha questo
    * skin come riferimento per il suo ambiente demo.
    * Quando verrà rimossa ricordare di cancellare anche
    * la cartellina "innovademo" con dentro i loghi di questa
    * skin. La nuova ha la cartella "innova".
    * La skin effettiva è quella immediatamente successiva
    * a questa.
    ***********************************/
    innovademo : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/innovademo/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/innovademo/logo_login_inferiore.png'),
          style : {
            border : '1px solid #fffff',
            borderRadius: '5px'
          }
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#143c54"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#143c54"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #ef7d00',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/innovademo/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#143c54"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#143c54"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #ef7d00',
          borderRadius: '5px',
          color: '#143c54'
        },
        // Pulsante di invio
        send_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#143c54'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/innovademo/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#143c54'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#143c54',
          '--hover-color' : '#246791'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#ef7d00',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#ef7d00',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#143c54',
          color : '#ffffff',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#ef7d00',
          '--border-color' : '#ef7d00',
          '--text-color' : '#ffffff'
        }
      }
    },
    /*********************************
    * SKIN PER PORTALE INNOVA
    ***********************************/
    innova : {
      /**
       * SKIN COMPONENTE - LOGIN FORM
       */
      LoginForm : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login ( come riferimento considerare un'immagine di 300px di larghezza )
        img_logo : require('@/assets/logos/innova/logo_login.png'),
        // Stile immagine del login
        img_logo_style : {},
        // Sottotitolo del logo
        // elemento speciale: non contiene solo lo style
        // ma anche variabili per impostarne il contenuto e
        // renderlo o meno visibile
        logo_subtitle : {
          text : '',
          visible : false,
          style : {}
        },
        // Logo inferiore ( posto sotto al form di login )
        // se previsto.
        logo_inf : {
          visible: true,
          img_logo : require('@/assets/logos/innova/logo_login_inferiore.png'),
          style : {
            border : '1px solid #fffff',
            borderRadius: '5px'
          }
        },
        // Gruppo form per lo username
        username_text_and_icon : {
          color: "#143c54"
        },
        // Gruppo form per la password
        passwd_text_and_icon : {
          color: "#143c54"
        },
        // Body del form di login
        form_body : {
          background : '#ffffff',
          border : '2px solid #ef7d00',
          borderRadius: '5px'
        },
        // Pulsante di accesso
        access_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff'
        },
        // Pulsante password dimenticata
        passwd_lost_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff',
        }
      },
      /**
       * SKIN COMPONENTE - PASSWORD RESET
       * ( FORM RECUPERO PASSWORD PERDUTA/SCADUTA )
       */
      PasswordReset : {
        body : {
          background: '#ffffff'
        },
        // Immagine del login
        img_logo : require('@/assets/logos/innova/logo_login.png'),
        // Sottotitolo del form "Reset Password Perduta"
        subtitle_text : {
          color: "#143c54"
        },
        // Testo informativo della pagina sia in caso di caricamento corretto che di errore
        info_text : {
          color: "#143c54"
        },
        // Corpo del form
        form_body : {
          background : '#ffffff',
          border : '2px solid #ef7d00',
          borderRadius: '5px',
          color: '#143c54'
        },
        // Pulsante di invio
        send_button : {
          background: '#143c54',
          borderColor: '#143c54',
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HomeBase
       */
      HomeBase : {
        body : {
          background: '#ffffff'
        },
        // Colorazione della barra del footer
        footer : {
          /* Le prime due righe rimuovono la proprietà 'flex'
          la quale costringe il testo a partire da sinistra
          anche se il b-navbar-nav riporta la proprietà 'center' */
          display: 'inline-block',
          width: '100%',
          background: '#143c54'
        },
        // Colorazione del testo del footer
        footer_text : {
          color: '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - NAVBAR
       */
      SiteNavbar : {
        body : {
        },
        // Gestice la presenza del logo nella navbar in alto
        // Componente speciale : non è solo uno style da applicare
        // va definisce anche la presenza o meno dell'immagine nella navbar
        nav_logo : {
          // Immagine del login
          img_logo : require('@/assets/logos/innova/logo_navbar.png'),
          visible : true
        },
        // Colore di sfondo della navbar
        navbar : {
          background: '#ffffff'
        },
        // Stile del nome utente
        username : {
          color : '#143c54'
        },
        // Colore dei testi e delle icone della navbar
        // normalmente ed in hover.
        // Lasciare l'oggetto vuoto per il colore di default.
        // Usa una variabile css per l'applicazione ( vedi
        // il componente per le info )
        navbar_text_color: {
          '--text-color' : '#143c54',
          '--hover-color' : '#246791'
        }
      },
      /**
       * SKIN COMPONENTE - HOME MENU
       */
      HomeDipendente : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#ef7d00',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - HOME REF AZIENDALE
       */
      HomeRefAziendale : {
        body : {
        },
        // Header delle varie sezioni del menù principale
        header_sezioni : {
          background: '#ef7d00',
          color : '#ffffff'
        }
      },
      /**
       * SKIN COMPONENTE - SERVICE BADGE
       */
      ServiceBadge : {
        body : {
        },
        // Footer delle voci di menù
        voci_menu : {
          padding: '10px',
          background: '#143c54',
          color : '#ffffff',
          fontWeight : '600'
        }
      },
      /**
       * SKIN COMPONENTE - DOCUMENTAZIONE VIEW ( Pagina documentazione )
       */
      DocumentazioneView : {
        body : {},
        // Bottoni che aprono/chiudono gli accordion della pagina
        accordion_button : {
          '--background-color' : '#ef7d00',
          '--border-color' : '#ef7d00',
          '--text-color' : '#ffffff'
        }
      }
    }
  }
}

export { customerColorMap };